<template>
  <div class="loader-wrapper d-flex justify-content-center align-items-center" :style="wrapperStyle">
    <component :is="loaderComponent" />
  </div>
</template>

<script>
import LoaderDefault from '@/components/loaders/default.vue';
import LoaderSpinnerMorphC from '@/components/loaders/spinner-morph-c.vue';

const LOADER_TYPES = {
  default: LoaderDefault,
  'spinner-morph-c': LoaderSpinnerMorphC,
};

export default {
  props: {
    type: {
      type: String,
      default: 'default',
      validator(value) {
        return Object.keys(LOADER_TYPES).includes(value);
      },
    },
    wrapperStyle: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    loaderComponent() {
      return LOADER_TYPES[this.type] || LOADER_TYPES.default;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../styles/components/_loader.scss";
</style>